import * as XLSX from 'xlsx';
import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
const   monthArray  = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]
export const ExportExcelButton = ({ data, fileName, buttonText = "Export to Excel", className = "", style = {} }) => {
    // console.log("filename" ,fileName);
    
    const exportToExcel = () => {
        // Format the data for Excel export
        const formattedData = data.map(item => ({
            "Employee ID": `Name :  ${item.employee_id}`,
            "Name": item.name,
            "Employee Code": item.employee_code,
            "Department": item.department,
            "Designation": item.designation,
            "Date": item.date,
            "Day": item.day,
            "Month": item.month,
            "Year": item.year,
            "Shift Timing": item.shift_timing,
            "Login Time": item.login_time || "N/A",
            "Logout Time": item.logout_time || "N/A",
            "Attendance Status": item.attendance_status || "N/A",
            "Work Status": item.work_status,
            "Productive Hours": item.productive_hours || "0.00",
            "Location": item.location,
            "Office Location": item.office_location,
            "Reporting Manager": item.reporting_manager,
            "Status": item.status,
            "Mobile": item.mobile,
            "Email": item.email
        }));

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(formattedData);

        // Set column widths
        const wscols = [
            { wch: 10 },  // Employee ID
            { wch: 20 },  // Name
            { wch: 15 },  // Employee Code
            { wch: 15 },  // Department
            { wch: 20 },  // Designation
            { wch: 12 },  // Date
            { wch: 10 },  // Day
            { wch: 8 },   // Month
            { wch: 6 },   // Year
            { wch: 12 },  // Shift Timing
            { wch: 12 },  // Login Time
            { wch: 12 },  // Logout Time
            { wch: 18 },  // Attendance Status
            { wch: 10 },  // Work Status
            { wch: 15 },  // Productive Hours
            { wch: 30 },  // Location
            { wch: 15 },  // Office Location
            { wch: 20 },  // Reporting Manager
            { wch: 12 },  // Status
            { wch: 12 },  // Mobile
            { wch: 25 }   // Email
        ];
        ws['!cols'] = wscols;

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Attendance Data");

        // Export the file
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    return (
        <button
            onClick={exportToExcel}
            className={`px-3 py-1 bg-black text-white rounded hover:bg-gray-800 flex items-center justify-center ${className}`}
            style={{
                fontSize: "12px",
                fontWeight: "600",
                fontFamily: "Inter",
                color: "white",
                lineHeight: "18px",
                ...style
            }}
        >
            {buttonText}
        </button>
    );
};



export const ExportExcelButtonMonthly = ({
    data,
    fileName = "monthly_attendance_report",
    buttonText = "Export to Excel",
   details
}) => {

    const exportToExcel = async () => {
        const getDaysInMonth = (year, month) => {
            const daysInMonth = new Date(year, month, 0).getDate(); // month is 1-based for this use
            const daysArray = Array.from({ length: daysInMonth }, (_, i) => `Day ${i + 1}`);
            return daysArray;
        };

        // Example: May 2025
        // console.log(details,monthArray.findIndex(month => month === details.leaveMonth) , );
        const monthIndex = monthArray.findIndex(month => month === details.leaveMonth) +1;

        
        const allDays = getDaysInMonth(details?.leaveYear, monthIndex); // 5 for May
        // console.log(allDays);


        // Convert to sorted array (Day 1, Day 2, etc.)
        const sortedDays = Array.from(allDays).sort((a, b) =>
            parseInt(a.replace('Day ', '')) - parseInt(b.replace('Day ', ''))
        );

        const processedData = data.map((employee) => {
            const attendanceDays = employee?.attendance || {};

            const flattenedAttendance = {};
            // Ensure all days are included, even if empty for this employee
            sortedDays.forEach(day => {
                const dayData = attendanceDays[day];
                const prodHours = dayData?.productive_hours !== undefined &&
                    dayData?.productive_hours !== null
                    ? dayData.productive_hours
                    : "0.00";

                flattenedAttendance[day] = dayData
                    ? `${dayData.status || "N/A"}\nLogin: ${dayData.in_time || "N/A"}\nLogout: ${dayData.out_time || "N/A"}\nProduction Hrs: ${prodHours} Hrs`
                    : "N/A";
            });

            const monthlyProdHours = employee?.monthly_productive_hours !== undefined &&
                employee?.monthly_productive_hours !== null
                ? employee.monthly_productive_hours
                : "0.00";

            const deductionSummary = [
                `Total Late: ${employee?.late_count || 0}`,
                `Paid Leave: ${employee?.paid_Leave || 0}`,
                `Unpaid Leave: ${employee?.unpaid_leave || 0}`,
                `Total Production: ${monthlyProdHours} Hrs`
            ].join('\n');

            return {
                "Employee": [
                    `Name: ${employee?.name}`,
                    `ID: ${employee?.employee_id || "N/A"}`,
                    `Dept: ${employee?.department || "N/A"}`
                ].join('\n'),
                "Summary": deductionSummary,
                ...flattenedAttendance
            };
        });

        // Create workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Attendance');

        // console.log("sortedDays", sortedDays);

        // Create columns (Employee, Summary, then all days)
        const dynamicColumns = [
            { header: 'Employee', key: 'Employee', width: 35 },
            { header: 'Summary', key: 'Summary', width: 35 },
            ...sortedDays.map(day => ({
                header: day,
                key: day,
                width: 35
            }))
        ];

        worksheet.columns = dynamicColumns;

        // Style header row
        const headerRow = worksheet.getRow(1);
        headerRow.height = 30;
        headerRow.font = { bold: true };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

        // Add data rows
        processedData.forEach(item => {
            worksheet.addRow(item);
        });

        // Apply cell styling
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) {
                row.eachCell((cell) => {
                    cell.alignment = {
                        vertical: 'top',
                        horizontal: 'left',
                        wrapText: true
                    };
                });
                row.height = 90;
            }
        });

        // Generate and download
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
            `${details.leaveMonth}-${fileName}.xlsx`
        );
    };

    return (
        <button onClick={exportToExcel} className={"btn btn-primary"} style={{padding:"4px"}}>
            {buttonText}
        </button>
    );
};